import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Paper } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { formatListItemDate } from '../../../Helpers/dates';
import CaptionValue from '../../../Components/CaptionValue/CaptionValue';
import IconButton from '../../../Components/Button/IconButton';

const BranchSourcesEntry = function BranchSourcesEntry({
  key,
  branchSourcesData,
  openEditBranchSourceDialog,
}) {
  return (
    <Paper
      id={`${key}-branch-source-item`}
      variant="outlined"
      onClick={() => openEditBranchSourceDialog(branchSourcesData)}
      sx={{ mb: '8px' }}
    >
      <Grid spacing={1} container sx={{ padding: '16px' }}>
        <Grid size={{ xs: 1.5 }}>
          <CaptionValue
            flex="1 1 30%"
            valueStyle={{ fontWeight: 500 }}
            caption="SourceName"
            value={branchSourcesData.sourceName}
          />
        </Grid>
        <Grid size={{ xs: 1 }}>
          <CaptionValue
            flex="1 1 30%"
            valueStyle={{ fontWeight: 500 }}
            caption="Direction"
            value={branchSourcesData.direction ? 'Input' : 'Output'}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <CaptionValue
            flex="1 1 30%"
            valueStyle={{ fontWeight: 500 }}
            caption="FileId"
            value={branchSourcesData?.fileId?.toString()}
          />
        </Grid>
        <Grid size={{ xs: 1 }}>
          <CaptionValue
            flex="1 1 30%"
            valueStyle={{ fontWeight: 500 }}
            caption="SheetName"
            value={branchSourcesData?.sheetName}
          />
        </Grid>
        <Grid size={{ xs: 1.5 }}>
          <CaptionValue
            flex="1 1 30%"
            valueStyle={{ fontWeight: 500 }}
            caption="CompletedOn"
            value={formatListItemDate(branchSourcesData?.completedOn, true)}
          />
        </Grid>
        <Grid size={{ xs: 1 }}>
          <CaptionValue
            flex="1 1 30%"
            valueStyle={{ fontWeight: 500 }}
            caption="Frequency"
            value={branchSourcesData?.frequency?.toString()}
          />
        </Grid>
        <Grid size={{ xs: 1 }}>
          <CaptionValue
            flex="1 1 30%"
            valueStyle={{ fontWeight: 500 }}
            caption="CellRange"
            value={branchSourcesData?.cellRange?.toString()}
          />
        </Grid>
        <Grid size={{ xs: 1.5 }}>
          <CaptionValue
            flex="1 1 30%"
            valueStyle={{ fontWeight: 500 }}
            caption="RootId"
            value={branchSourcesData?.rootId?.toString()}
          />
        </Grid>

        <IconButton
          title="EDIT_BRANCHSOURCE"
          size="large"
          onClick={(e) => {
            e.stopPropagation();
            openEditBranchSourceDialog(branchSourcesData);
          }}
        >
          <EditIcon />
        </IconButton>
      </Grid>
    </Paper>
  );
};
BranchSourcesEntry.propTypes = {
  branchSourcesData: PropTypes.object,
  key: PropTypes.object,
  openEditBranchSourceDialog: PropTypes.func,
};
export default BranchSourcesEntry;
